import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-reference-link-for-all',
  templateUrl: './reference-link-for-all.component.html',
  styleUrls: ['./reference-link-for-all.component.scss']
})
export class ReferenceLinkForAllComponent implements OnInit {
  API_URL = `${environment.apiUrlRules}`;
  loading = false;
  id: string;
  rules$: Observable<any>; // Updated to an Observable

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient
  ) {
    this.route.params.subscribe(params => {
      this.id = params['id'];
      const firstPart = this.id.split('_')[0];
      this.fetchRules(firstPart);
    });
  }

  ngOnInit() {

  }

  fetchRules(firstPart:any) {
    this.loading = true;
    this.rules$ = this.http.get(`${this.API_URL}/rule-files/list`, {
      params: {
        ruleId: firstPart,
      }
    });
    this.rules$.subscribe((res: any) => {
      // console.log(res);
      this.loading = false;
    });
  }

  getIconClass(fileName: string): string {
    const fileExtension = fileName.split('.').pop()?.toLowerCase();

    if (fileExtension === 'xlsx' || fileExtension === 'xls') {
      return 'fas fa-file-excel blue-icon';
    } else if (fileExtension === 'pdf') {
      return 'fas fa-file-pdf red-icon';
    } else if (fileExtension === 'docx' || fileExtension === 'doc') {
      return 'fas fa-file-word green-icon';
    } else if (fileExtension === 'png' || fileExtension === 'jpeg' || fileExtension === 'jpg') {
      return 'fas fa-file-image orange-icon';
    }

    return 'fas fa-file default-icon'; // Default file icon
  }
}
